import { BaseFieldProps } from "./BaseFieldProps";
import React from "react";
import { OIDCUrlField } from "./OIDCUrlField";

export const JsonWebKeySetURLField = ({ disabled = false, onChange, value = "" }: BaseFieldProps) => {
    return (
        <OIDCUrlField
            id="jwks"
            label="JWKS URL"
            placeholder="JWKS URL"
            description="URL of the JSON Web Key Set [JWK] document"
            examples={["(i.e. https://idp.example.com/oauth2/keys)"]}
            disabled={disabled}
            onChange={onChange}
            value={value}
        />
    );
};

JsonWebKeySetURLField.displayName = "JsonWebKeySetURLField";
